module.exports = __webpack_public_path__ + "images/rovo_collection_3.ed1f035288f6e0df632719db363f3dd2.png";